/// <reference path="../../services/setting.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {SettingService} SettingService
 */
function bbSettingController(SettingService, $scope, $q) {
    this.svc = SettingService;

    this.data = {
        settings: []
    };

    this.loading = {
        settings: true,
    };

    this.errors = {
    };

    this.modals = {

    }

    this.onSettingsResetClick = () => {
        this.loading.settings = true;
        this.data.settings = [];
        SettingService.get()
            .then(r => {
                $scope.settingsForm.$setPristine();
                this.data.settings = r;
            })
            .finally(() => {
                this.loading.settings = false;
            });
    }

    this.onSettingsSubmit = () => {
        const updates = $scope.settingsForm.$$controls.filter(c => c.$dirty).map(c => ({name: c.$name, value: c.$modelValue}));
        if (!updates.length) {
            $scope.settingsForm.$setPristine();
            return;
        }

        this.loading.settings = true;
        for (const update of updates) {
            if (SettingService.isBooleanSetting(update.name)) {
                update.value = update.value === "1" ? "yes" : "no";
            }
        }

        const promises = updates.map(u => SettingService.patch(u.name, { value: u.value }));
        $q.all(promises).finally(() => {
            this.onSettingsResetClick();
        });
    }

    this.onSettingsResetClick();
}

mod.component('bbSettings', {
    templateUrl: 'tpl/bb-settings.component.html',
    bindings: {},
    controller: ["SettingService", "$scope", "$q", bbSettingController]
});